"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
var angular = require("angular");
var scatter_plot_chart_1 = require("./scatter-plot.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
var ScatterPlotComponent = /** @class */ (function (_super) {
    __extends(ScatterPlotComponent, _super);
    function ScatterPlotComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'ScatterPlot') || this;
        _this.changeLabelLength = function (change) {
            if (change === void 0) { change = 0; }
            var ctrl = _this;
            if (!ctrl.settings.charsInLabel) {
                ctrl.settings.charsInLabel = 0;
            }
            ctrl.settings.charsInLabel = parseInt(ctrl.settings.charsInLabel);
            ctrl.settings.charsInLabel += change;
            ctrl.drawChart();
        };
        var ctrl = _this;
        $scope.$on('command:SCATTER_PLOT', function (event, args) { return ctrl.initComponent(event, args); });
        return _this;
    }
    ScatterPlotComponent.prototype.getChartOptions = function (graph, options) {
        return scatter_plot_chart_1.getChartOptions(graph, options);
    };
    ScatterPlotComponent.prototype.makeChart = function (chartOptions) {
        var chartGot = basic_chart_component_1.makeChart(chartOptions, this.getAdditionalChartCallback());
        basic_chart_component_1.handleResponsiveNess(chartGot);
        return chartGot;
    };
    ScatterPlotComponent.prototype.drawChart = function () {
        var ctrl = this;
        var graphData = JSON.parse(JSON.stringify(ctrl.selectedGraph)) || [];
        ctrl.tableData.inputData = graphData;
        ctrl.tableData = JSON.parse(JSON.stringify(ctrl.tableData));
        var timestamp = ctrl.settings.timestampMode === 'lastRecalc' ? ctrl.getDate(ctrl.currentNode.lastRecalc) : ctrl.getDate();
        var chartOptions = ctrl.getChartOptions(graphData, {
            currentNode: ctrl.currentNode,
            chartTitle: ctrl.actionMenuItem,
            legends: ctrl.legends,
            settings: ctrl.settings,
            timestamp: timestamp
        });
        // Use transformed data for table if available (for leaf nodes)
        if (chartOptions.transformedTableData) {
            ctrl.tableData.inputData = chartOptions.transformedTableData;
            ctrl.tableData = JSON.parse(JSON.stringify(ctrl.tableData));
        }
        var chartGot = basic_chart_component_1.makeChart(chartOptions, ctrl.getAdditionalChartCallback());
        basic_chart_component_1.handleResponsiveNess(chartGot);
    };
    ScatterPlotComponent.prototype.getDate = function (timestamp) {
        if (timestamp === void 0) { timestamp = null; }
        if (timestamp === '-') {
            return timestamp;
        }
        var date = timestamp ? new Date(timestamp) : new Date();
        var dateInString = date.toString();
        var splitTimestamp = dateInString.split(" ");
        var timeWithoutSec = splitTimestamp[4].substring(0, splitTimestamp[4].length - 3);
        var timeZone = splitTimestamp.slice(6, splitTimestamp.length);
        return "" + splitTimestamp[1] + " " + splitTimestamp[2] + " " + splitTimestamp[3] + " " + timeWithoutSec + " " + timeZone + "";
    };
    ScatterPlotComponent = __decorate([
        basic_chart_component_1.Component({
            bindings: {
                menu: '='
            },
            template: require("./scatter-plot.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], ScatterPlotComponent);
    return ScatterPlotComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.ScatterPlotComponent = ScatterPlotComponent;
angular.module('smartorg.r6.acts.scatterPlot', []).component('scatterPlot', ScatterPlotComponent);
module.exports = 'smartorg.r6.acts.scatterPlot';
//# sourceMappingURL=scatter-plot.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/scatter-plot2/scatter-plot.component.js